import { Box } from '@mui/material';
import Slide from '@mui/material/Slide';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import * as SelectionContainer from './M_BottomSelectionContainer';
import * as TabContainer from './M_BottomTabContainer';

export interface Props {
    open: boolean;
    optionsLoading: boolean;
    tabs: {
        header: string;
        id: string;
        types: ReadonlyArray<string>;
    }[];
    options: {
        id: string;
        image: string;
        type: string;
    }[];
    onTabChange: (id: string) => void;
    onCatalogueStateChange: (id: string, isOpen: boolean) => void;
    selectedOption?: string;
    onSelect: (id: string) => void;
}

export const Component = (p: Props) => {
    const [activeTab, setActiveTab] = Hooks.useState<string>(p.tabs[0].id);

    Hooks.useEffect(() => {
        const tabType = p.options.find(o => o.id === p.selectedOption)?.type;
        const tabSelection = p.tabs.find(t => tabType && t.types.includes(tabType))?.id;

        setActiveTab(tabSelection || p.tabs[0].id);
    }, [p.selectedOption, p.options]);

    return (
        <Slide
            in={p.open}
            direction="up"
            timeout={{ enter: 225, exit: 225 }}
            easing="cubic-bezier(0, 0, 0.2, 1)"
            onEntered={() => p.onCatalogueStateChange(activeTab, p.open)}
            onExit={() => p.onCatalogueStateChange(activeTab, p.open)}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateRows: '48px auto',
                    width: '100%',
                    height: '150px',
                    position: 'absolute',
                    bottom: 0,
                    filter: 'drop-shadow(0 4px 80px rgba(0,0,0,0.1))',
                    backgroundColor: '#FFFFFF',
                }}
            >
                <TabContainer.Component
                    tabs={p.tabs}
                    options={p.options}
                    activeTab={activeTab}
                    onClick={(id: string) => {
                        p.onTabChange(id);
                        setActiveTab(id);
                    }}
                />
                <SelectionContainer.Component
                    loading={p.optionsLoading}
                    selectedOption={p.selectedOption}
                    options={p.options.filter(option =>
                        p.tabs.find(t => t.id === activeTab)?.types.includes(option.type),
                    )}
                    onClick={(id: string) => {
                        p.onSelect(id);
                    }}
                />
            </Box>
        </Slide>
    );
};

Component.displayName = 'BottomSelectionMenu';
